require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-xa-6-wl.json") })
        }
      }, "path---photos-professional-xa-6-wl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-xa-6-wl!./.cache/json/photos-professional-xa-6-wl.json
// module id = 948
// module chunks = 231608221292675